<template>
    <div class="order-list-wrap">
        <div class="info-item" v-for="(order, index) in list" :key="index">
            <div class="info-title">
                <div class="date">{{ order.createdTime }}</div>
                &nbsp&nbsp&nbsp
                <div class="order-code">
                    订单号：<span>{{ order.orderNo }}</span>
                </div>
            </div>
            <div class="info-good">
                <div class="list-good">
                    <div class="item-good">
                        <div class="img-box">
                            <el-image class="elImg" :src="order.products.image" fit="cover"></el-image>
                        </div>
                        <div class="title">{{ order.products.title }}</div>
                        <div class="title2">{{ order.products.keyVals }}</div>
                        <div class="num">x {{ order.products.num }}</div>
                        <div class="price">{{ order.products.priceSale }}元</div>
                        <button
                            class="order-detail btn-ripple"
                            @click="$router.push(`/refund-type?order_id=${order.orderId}&inventoryId=${order.inventoryId}`)"
                        >
                            申请售后
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'orderList',
    components: {},
    props: ['list'],
    data() {
        return {}
    },
    computed: {},
    mounted() {},
    methods: {},
}
</script>

<style scoped lang="less">
.order-list-wrap {
    .info-item {
        border: 1px solid #e5e5e5;
        margin-bottom: 24px;
    }

    .info-title {
        .flex-between();
        height: 48px;
        padding: 0 24px;
        background: #f5f5f5;
        border-bottom: 1px solid #e5e5e5;

        .infoText {
            font-size: 14px;
            color: #333333;
        }

        .infoText2 {
            font-size: 14px;
            color: #888888;
        }

        .date {
            font-size: 14px;
            font-weight: bold;
            line-height: 20px;
            color: #333333;
        }
        .order-code {
            flex: 2;
            text-align: left;
            // padding-left: 20px;

            font-size: 14px;
            font-weight: bold;
            line-height: 20px;
            color: #333333;
            span {
                color: #333333;
            }
        }
        .order-state {
            padding: 3px 6px;
            border: 1px solid #ccc;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 20px;
            color: #999999;

            &.state2 {
                color: #ff4d00;
                border-color: #ff4d00;
            }
        }
    }

    .orderStatusType {
        display: flex;
        align-items: center;
        justify-content: center;

        .orderStatusIcon {
            width: 22px;
            display: block;
            margin-right: 4px;
        }

        .text {
            font-size: 14px;
            line-height: 14px;
            color: #ff4d00;
        }
    }

    .info-good {
        .list-good {
            .item-good {
                padding: 20px;
                border-bottom: 1px solid #e5e5e5;
                display: flex;
                align-items: center;
                justify-content: space-between;

                &:last-child {
                    border: none;
                }

                .img-box {
                    width: 120px;
                    height: 83px;
                    border: 1px solid #9f9f9f;
                    overflow: hidden;

                    .elImg {
                        width: 120px;
                        height: 83px;
                    }
                }

                .title {
                    text-align: left;
                    padding-left: 20px;
                    font-size: 14px;
                    font-weight: 400;
                    line-height: 20px;
                    color: #333333;
                }

                .title2 {
                    text-align: left;
                    padding-left: 20px;
                    font-size: 14px;
                    font-weight: 400;
                    line-height: 20px;
                    color: #333333;
                }

                .num {
                    width: 100px;
                    font-size: 16px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    line-height: 20px;
                    color: #333333;
                }

                .price {
                    min-width: 100px;
                    font-size: 16px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    line-height: 20px;
                    color: #333333;
                }

                .order-detail {
                    width: 104px;
                    height: 32px;
                    background: #ffffff;
                    border-radius: 0px 0px 0px 0px;
                    border: 1px solid #cecece;
                    transition: 0.3s;
                    font-size: 14px;
                    color: #555555;

                    &:hover {
                        opacity: 0.8;
                    }
                }
            }
        }
    }
    .info-heji {
        padding: 15px;
        border-top: 1px solid #ccc;
        .flex-between();
        justify-content: flex-end;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 20px;
        color: #7d7d7d;
    }
}
</style>
